/** Rôles applicatifs. */
export const ROLES = ["admin", "client"] as const;
export type Role = (typeof ROLES)[number];

/** Cycle de vie d'un média invité. */
export const MEDIA_STATUSES = [
  "uploading", // URL présignée émise, upload navigateur en cours
  "processing", // upload terminé, job worker en file / en cours
  "ready", // dérivés générés, visible dans la galerie
  "failed", // échec transcodage / traitement
] as const;
export type MediaStatus = (typeof MEDIA_STATUSES)[number];

export const MEDIA_KINDS = ["image", "video"] as const;
export type MediaKind = (typeof MEDIA_KINDS)[number];

/** Variantes stockées pour un média. */
export const RENDITION_KINDS = [
  "thumb", // vignette (image ou poster vidéo)
  "full", // image plein écran (AVIF/WebP)
  "poster", // image extraite d'une vidéo
  "mp4", // vidéo H.264 de compatibilité
  "hls", // playlist HLS (master .m3u8)
] as const;
export type RenditionKind = (typeof RENDITION_KINDS)[number];

/** Statuts d'une demande de prix (lead). */
export const QUOTE_STATUSES = [
  "new",
  "contacted",
  "quoted",
  "won",
  "lost",
] as const;
export type QuoteStatus = (typeof QUOTE_STATUSES)[number];

/** Limites d'upload (octets). */
export const MAX_IMAGE_BYTES = 25 * 1024 * 1024; // 25 Mo
export const MAX_VIDEO_BYTES = 2 * 1024 * 1024 * 1024; // 2 Go
export const MAX_VIDEO_DURATION_S = 180; // 3 min

/** Types MIME acceptés côté ingestion. */
export const ACCEPTED_IMAGE_MIME = [
  "image/jpeg",
  "image/png",
  "image/webp",
  "image/heic",
  "image/heif",
  "image/avif",
] as const;

export const ACCEPTED_VIDEO_MIME = [
  "video/mp4",
  "video/quicktime",
  "video/webm",
  "video/x-matroska",
  "video/3gpp",
] as const;

/** Délai par défaut avant révélation de la galerie aux invités (ms). */
export const DEFAULT_REVEAL_OFFSET_MS = 24 * 60 * 60 * 1000; // 24 h après l'événement

/** Durée de validité du lien invité signé. */
export const GUEST_TOKEN_TTL = "180d";

/** Durée de validité d'un lien d'invitation client. */
export const INVITE_TTL_MS = 7 * 24 * 60 * 60 * 1000; // 7 jours

/** Durée de validité d'un lien de réinitialisation de mot de passe. */
export const PASSWORD_RESET_TTL_MS = 60 * 60 * 1000; // 1 heure

/** Pagination galerie. */
export const GALLERY_PAGE_SIZE = 24;

/** Cookie de session. */
export const SESSION_COOKIE = "sv_session";
